import { render } from "./SectionAccessTab.vue?vue&type=template&id=365021e5&scoped=true"
import script from "./SectionAccessTab.vue?vue&type=script&lang=js"
export * from "./SectionAccessTab.vue?vue&type=script&lang=js"

import "./SectionAccessTab.vue?vue&type=style&index=0&id=365021e5&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365021e5"]])

export default __exports__